export default [
  {
    path: '/hospital/coupon/618/:type',
    name: 'coupon618guide',
    component: () => import('./618/guide'),
    auth: false,
    exact: true,
    realAuth: false,
    title: '众安 618 优惠',
  },
]
